import { render } from "./UnCryptoHoldingHistory.vue?vue&type=template&id=e553ecac"
import script from "./UnCryptoHoldingHistory.vue?vue&type=script&lang=js"
export * from "./UnCryptoHoldingHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__